const translations = {
  app_name: "FormWeg",
  customers: {
    assigned_to: "Assigned inspector",
    assign_to_me: "Assign to me",
    new_customer: "New customer",
    unassigned: "Unassigned",
  },
  contacts: {
    contacts: "Contacts",
    kinds: {
      phone: "Phone",
      mobile: "Mobile",
      fax: "Fax",
      email: "Email",
    },
  },
  delivery_notes: {
    cancel: "Cancel",
    assigned_to: "Assigned to",
    assign_to_me: "Assign to me",
    unassigned: "Unassigned",
    removed_from_template: "No longer in {{name}} template",
    work_order_items_group: "From $t(work_orders.work_order)",
    performed_by: "Performed by",
    no_performer: "No performer",
    coworker_badge: "Staff",
    link_work_order: "Link $t(work_orders.work_order)",
    audit: "History",
    errors: {
      number_already_exists: "Item number already exists in the template",
      performed_by_required:
        "Please select a performer before completing the report.",
      invalid_performed_by_id: "The selected user is not a technician.",
    },
    menu: {
      confirm_copy: "Do you really want to copy this $t(delivery_notes.delivery_note)?",
      advancing_next: "Advancing to next $t(delivery_notes.delivery_note)…",
    },
    templates: {
      no_documentation: "No documentation configured",
      add_column: "Column",
      add_field: "Field",
      add_group: "Group",
      add_field_to_group: "Field",
      add_row: "Row",
      col_name: "Column name",
      group_name: "Group name",
      empty_group: "No fields in this group",
      row_label: "Row label",
      default_value: "Default value",
      default_values: "Default values",
      choices_hint: "Options (comma separated)",
      field_unit: "Unit (e.g. bar, cm, s)",
      document_fields: "Document fields",
      add_document_field: "Document field",
      no_document_fields: "No document fields configured",
      field_description_placeholder: "Description / notice (optional)",
      widgets: {
        text: "Text",
        number: "Number",
        boolean: "Checkbox",
        select: "Select",
        radio: "Radio",
        date: "Date",
      },
      import_excel: {
        button: "Import",
        title: "Import documentation from Excel/CSV",
        step_file: "File",
        step_options: "Options",
        step_columns: "Columns",
        step_mapping: "Mapping",
        step_preview: "Preview",
        mode_label: "How should the import be applied?",
        mode_fill: "Fill existing fields",
        mode_fill_hint: "Keeps the configured fields and fills them with the imported values.",
        mode_replace: "Replace documentation",
        mode_replace_hint: "The imported columns replace the current fields and rows.",
        choose_file: "Choose file",
        drop_hint: "Drop a .xlsx, .xls or .csv file here, or click to select",
        file_selected: "Selected: {{name}}",
        parse_error: "Could not parse the file. Please check the format.",
        use_first_row_as_headers: "Use first row as column titles",
        ignore_empty_columns: "Ignore empty columns",
        delimiter: "Delimiter (CSV)",
        delimiter_auto: "Auto-detect",
        delimiter_comma: "Comma (,)",
        delimiter_semicolon: "Semicolon (;)",
        delimiter_tab: "Tab",
        delimiter_pipe: "Pipe (|)",
        sheet: "Sheet",
        no_columns: "No columns detected.",
        select_columns_hint: "Select which columns to import. All values will be imported as plain text.",
        mapping_hint: "Assign each column to a field. Columns with matching names are pre-assigned; unassigned columns are not imported.",
        mapping_skip: "Do not import",
        unmapped_fields: "Fields without imported data: {{fields}}",
        empty_column: "empty",
        sample_value: "Sample: {{value}}",
        column_count: "{{count}} columns",
        row_count: "{{count}} rows",
        replace_warning: "This will replace the current documentation columns and rows.",
        fill_warning: "The existing rows will be replaced. The fields themselves are kept.",
        new_options_warning: "Values not among the configured options will be added as new options:",
        cancel: "Cancel",
        back: "Back",
        next: "Next",
        replace: "Replace",
        import: "Import",
        imported_badge: "Imported: {{details}}",
      },
    },
    alerts: {
      reviewed:
        "$t(delivery_notes.delivery_note) is already marked as reviewed and can no longer be changed.",
      save_offline:
        "Saving failed — no internet connection. Your entries are kept on this page, save again as soon as you are back online.",
      save_offline_restored: "Connection restored — please save again.",
      save_conflict:
        "$t(delivery_notes.delivery_note) was changed elsewhere in the meantime. Please reload the page and re-enter your changes.",
    },
  },
  work_orders: {
    work_orders: "Work Orders",
    work_order: "Work Order",
    number: "Number",
    add: "Create work order",
    status: "Status",
    created_at: "Created at",
    assigned_to: "Assigned to",
    assigned_at: "Assigned at",
    unassigned: "Unassigned",
    due_filter: "Due status",
    zip_filter: "Postal code",
    zip_filter_clear: "Clear selection",
    view: "View",
    view_list: "List",
    view_map: "Map",
    map_stats: "{{located}} of {{shown}} work orders located, {{unlocated}} without coordinates",
    map_truncated: "Only the first {{shown}} of {{total}} work orders are shown.",
    map_empty: "No work orders match the selected filters.",
    map_loading: "Loading map...",
    map_legend: "Legend",
    map_legend_other: "Other",
    due: "Due",
    overdue: "Overdue",
    not_due: "Not due",
    assign_to_me: "Assign to me",
    create_form: "Create $t(delivery_notes.delivery_note)",
    open_form: "Open $t(delivery_notes.delivery_note)",
    choose_template: "Choose $t(delivery_notes.templates.template)",
    link_form: "Link $t(delivery_notes.delivery_note)",
    create: "Create",
    link: "Link",
    unlink: "Unlink",
    confirm_unlink: "Do you really want to unlink $t(delivery_notes.delivery_note) {{number}}?",
    cancel: "Cancel",
    confirm_cancel: "Do you really want to cancel this $t(work_orders.work_order)?",
    canceled_by: "Canceled by",
    scheduled: "Scheduled",
    scheduled_short: "Date",
    scheduled_from: "Scheduled date",
    scheduled_until: "Scheduled until (optional)",
    availability: "Availability",
    availability_from: "Available from",
    availability_until: "Available until (optional)",
    remark: "Information",
    remark_original: "Original",
    remark_summary: "Summary",
    read_only: "This work order is no longer active and can no longer be edited.",
    audit: "History",
    items: "Items",
    no_items: "No items planned.",
    search_item: "Search item",
    document_details: {
      title: "Notes from documents",
      pending: "Evaluating documents …",
      failed: "Not all documents could be evaluated.",
      task: "Task",
      material: "Material",
      services: "Services",
      hints: "Notes",
      reference: "Reference",
      from_images: "Read from a PDF scan – may be inaccurate",
    },
    tabs: {
      open: "Open",
      unassigned: "Unassigned",
      in_progress: "In progress",
      done: "Done",
      canceled: "Canceled",
      all: "All",
    },
    states: {
      open: "Open",
      in_progress: "In progress",
      done: "Done",
      canceled: "Canceled",
    },
    origin_hint: {
      sqlbase: "Converted from the inspection interval.",
    },
    errors: {
      already_assigned: "This work order has already been assigned.",
      already_canceled: "This work order has already been canceled.",
      already_has_active_note: "This work order already has an active $t(delivery_notes.delivery_note).",
      already_linked: "This $t(delivery_notes.delivery_note) is already linked.",
      availability_until_before_from: "“Available until” must not be before “available from”.",
      scheduled_until_before_from: "“Scheduled until” must not be before “scheduled date”.",
      concurrent_edit: "The work order was modified in the meantime. Please refresh and try again.",
      customer_required: "Please provide a customer or a customer address.",
      customer_number_numeric: "Customer number must contain digits only.",
      delivery_note_canceled: "A canceled $t(delivery_notes.delivery_note) cannot be linked.",
      forbidden: "No permission for this work order.",
      has_delivered_note: "This work order can no longer be canceled because a delivered $t(delivery_notes.delivery_note) is linked.",
      invalid_assignee: "Invalid technician.",
      invalid_delivery_note: "$t(delivery_notes.delivery_note) not found.",
      invalid_filter: "Invalid filter.",
      invalid_item: "Item not found.",
      linked_elsewhere: "This $t(delivery_notes.delivery_note) is already linked to another work order.",
      not_active: "This work order is no longer active.",
      not_found: "Work order not found.",
      not_linked: "This $t(delivery_notes.delivery_note) is not linked to the work order.",
      not_open: "This work order is no longer open.",
      read_only: "This work order can no longer be edited.",
      unique_item_amount: "This item can only be planned in whole pieces.",
    },
  },
  files: {
    confirm_delete: "Are you sure you want to delete this file?",
    images: "Images",
    pdfs: "PDF files",
    attachment_formats: "PDF, JPG, PNG, WebP, HEIC/HEIF",
    drop_hint: "Drop files here or select files",
    drop_active: "Release files to upload",
    upload_constraints:
      "{{formats}} · max. {{maxFileSize}} per file · {{maxFiles}} files / {{maxTotalSize}} total",
    upload_queued: "Waiting to upload",
    upload_progress: "{{progress}}% · {{uploaded}} / {{total}}",
    upload_ready_for_save: "Ready – will be attached when saved",
    upload_failed: "Upload failed",
    upload_retry: "Try again",
    upload_cancel: "Cancel upload",
    upload_remove: "Remove file",
    upload_progress_label: "Upload of {{name}}",
    upload_duplicate: "“{{name}}” has already been selected.",
    upload_invalid_type: "“{{name}}” is not supported.",
    upload_invalid_size: "“{{name}}” is empty and cannot be attached.",
    upload_too_large: "“{{name}}” exceeds the {{maxSize}} limit.",
    upload_too_many: "No more than {{maxFiles}} files can be attached.",
    upload_total_too_large: "The files exceed the combined limit of {{maxSize}}.",
    preview: "Preview",
    preview_file: "Preview {{name}}",
    open: "Open",
    open_file: "Open {{name}}",
    download: "Download",
    download_file: "Download {{name}}",
    delete_file: "Delete {{name}}",
    errors: {
      too_many: "No more than 20 files can be attached.",
      invalid_size: "An empty file or a file with an invalid size cannot be attached.",
      too_large: "A file exceeds the 25 MB limit.",
      total_too_large: "The files exceed the combined limit of 100 MB.",
      duplicate_upload: "A file was submitted more than once.",
      upload_not_found: "An upload is no longer available. Please select the file again.",
      invalid_metadata: "A file has invalid information. Please select the file again.",
      size_mismatch: "A file size does not match its upload.",
      incomplete_upload: "A file was not uploaded completely.",
      hash_mismatch: "An uploaded file is damaged. Please upload it again.",
      invalid_type: "Only PDFs and supported image files can be attached.",
      extension_mismatch: "The file extension does not match the file format.",
    },
  },
  transcription: {
    recording: "Recording...",
    transcribing: "Transcribing...",
    error: "Transcription failed",
    mic_denied: "Microphone access denied",
  },
  markdown: {
    preview: "Preview",
    edit: "Edit",
  },
  assistant: {
    button: "Assistant",
    title: "Assistant",
    hint: "Paste text — fills the fields, keeps the original, and creates a summary in “$t(work_orders.remark)”.",
    placeholder: "Paste text here…",
    process: "Process",
    processing: "Processing…",
    errors: {
      unavailable: "The assistant is currently unavailable.",
      not_configured: "The assistant is not configured.",
      nothing_found: "No data could be extracted.",
    },
  },
  menu: {
    home: "Home",
    translations: "Labels",
    integrations: "Integrations",
    imports: "Imports",
    inspection_cards: "Inspection Overview",
    drafts: "Drafts",
    review: "To Review",
    logout: "Log Out",
  },
  inspections: {
    title: "Inspection Overview",
    month: "Month",
    year: "Year",
    month_invalid: "Invalid month",
    inspector: "Inspector",
    customer_nr: "Customer no.",
    customer: "Customer",
    property_nr: "Property no.",
    property: "Property",
    device_type: "Device type",
    next_inspection: "Next inspection",
    last_inspection: "Last inspection",
    schedule: "Schedule",
    interval: "Interval",
    card: "Inspection card",
    code: "Code",
    remark: "Remark",
    communications: "Communications",
    medium: "Medium",
    number: "Number",
    quantity: "Quantity",
    no_results: "No inspections found",
    convert: "Work order",
    convert_short: "Convert",
    confirm_convert: "Really convert this inspection due date into a work order?",
    confirm_convert_many:
      "Really convert {{count}} inspection due dates into work orders?",
    select_all: "Select all",
    clear_selection: "Clear selection ({{count}})",
    converted: "Converted",
    filter_converted: "Converted",
    filter_unconverted: "Not converted",
    open_work_order: "Open $t(work_orders.work_order)",
    errors: {
      already_converted: "This inspection has already been converted into a work order.",
      no_due_date: "This inspection has no due date.",
    },
    tab_list: "List",
    tab_map: "Map",
    map_stats: "{{located}} of {{total}} shown — {{unlocated}} addresses could not be located",
    map_loading: "Loading map...",
    map_empty: "No inspections available for the selected filters.",
    map_error: "Could not load map data.",
    map_legend: "Legend",
    map_legend_unknown: "Unknown",
  },
  nominatim: {
    unavailable:
      "The mapping service is currently unavailable. " +
      "Addresses cannot be displayed on the map.",
    unavailable_short: "Mapping service unavailable",
  },
  settings: {
    translations: {
      title: "Labels",
      description: "Customize labels for menu items and forms",
      delivery_notes_plural: "Delivery Notes (Plural)",
      delivery_notes_singular: "Delivery Note (Singular)",
      templates_plural: "Templates (Plural)",
      templates_singular: "Template (Singular)",
    },
    natrav: {
      title: "Secure Connection (Tunnel)",
      service: "Service",
      server: "Server",
      token: "Token",
      lokal: "Local",
      port: "Port",
    },
    sqlbase: {
      title: "SQLBase",
      db_name: "Database Name",
      username: "Username",
      password: "Password",
      confirm_overwrite: "Overwrite existing settings?",
      connection_ok: "Database connection successful. The connection will be active within 30 seconds.",
      connection_failed: "Database connection failed",
      authorization_title: "Authorization for Read-Only Database Access",
      authorization_accept: "Accept",
      authorization_accepted_by: "Accepted by {{name}} on {{date}} for {{db_name}} ({{version}})",
      cache: {
        title: "Cache",
        description:
          "Data from the legacy system (e.g. inspections, customers) is cached for several days. " +
          "Clear the cache after changes in the legacy system so the portal loads the current data.",
        size: "Cached queries",
        clear: "Clear cache",
        confirm: "Really clear the cache? The next queries to the legacy system will take longer.",
        cleared: "Cache cleared",
        clear_failed: "Cache could not be cleared",
      },
    },
    imports: {
      title: "Imports",
      tabs: {
        articles: "Articles",
      },
    },
    article_import: {
      title: "Import articles from legacy",
      description:
        "Syncs the article catalog from the legacy database into the portal. " +
        "Already adjusted fields (highlight, characteristic, inspection interval) " +
        "are preserved.",
      start: "Start import now",
      running: "Import running …",
      started: "Import started",
      already_running: "An import is already running",
      update_existing: "Update existing articles",
      update_existing_hint:
        "When enabled, the name and product group of existing articles are " +
        "overwritten from the legacy system. Highlight, characteristic and " +
        "inspection interval are preserved. When disabled, existing articles " +
        "are skipped.",
      empty_state:
        "No articles imported yet. Click \"Start import now\" to pull data from the legacy system.",
      started_at: "Started",
      finished_at: "Finished",
      duration: "Duration",
      pages: "Pages",
      show_errors: "Show {{count}} errors",
      counts: {
        created: "Created",
        updated: "Updated",
        skipped: "Skipped",
        errors: "Errors",
      },
      error: {
        handel_not_configured: "Legacy system URL is not configured.",
        sqlbase_not_configured: "SQLBase credentials are missing.",
      },
    },
  },
  common: {
    close: "Close",
    previous: "Previous",
    next: "Next",
    range_from: "from",
    range_until: "until",
    on_date: "on",
    confirm_unsaved_changes:
      "You have unsaved changes. Are you sure you want to leave?",
    offline: "No internet connection — saving is currently not possible.",
    deleted: "Deleted",
    move_up: "Move up",
    move_down: "Move down",
    choose: "Please select",
    reset_filters: "Reset filters",
    details: "Details",
    route: "Directions",
    route_to: "Directions to {{address}}",
  },
  users: {
    roles: "Roles",
    backoffice_access: "Backoffice access",
    no_backoffice_access: "No backoffice access",
    technician_access: "Works as technician",
    role_names: {
      administrator: "Administrator",
      manager: "Manager",
      technician: "Technician",
      office: "Office",
    },
    reset_password: "Generate new password",
    reset_password_confirm:
      "Generate a new password for this user? The current password will be invalidated immediately.",
    reset_password_generated: "New password generated",
    reset_password_warning:
      "This password is shown only once. Copy it now and hand it over to the user securely.",
    copy_password: "Copy password",
    password_copied: "Password copied to clipboard",
    password_copy_failed: "Could not copy password",
    last_seen: "Last seen",
  },
  errors: {
    item: {
      number_exists: "An item with this number already exists",
    },
    delivery_note: {
      invalid_transition: "Transition from {{from}} to {{to}} is not allowed",
      transition_forbidden: "Transition from {{from}} to {{to}} is not allowed for your role",
    },
    users: {
      invalid_roles: "This role combination is not allowed",
    },
    user_settings: {
      ineligible_role:
        "Notifications cannot be enabled for this user's role.",
    },
    unknown: "An unknown error occurred",
    types: {
      number: {
        number: "Value must be a number",
        positive: "Value must be a positive number",
      },
    },
  },

  notifications: {
    tab: {
      title: "Notifications",
      page_title: "Settings",
      ineligible_placeholder:
        "Notifications are not available for the current role.",
    },
    fields: {
      email: {
        delivery_note_delivered:
          "Email me when a $t(delivery_notes.delivery_note) is delivered",
      },
    },
    delivery_note_delivered: {
      email: {
        subject: "$t(delivery_notes.delivery_note) no. {{number}} was delivered",
        body:
          "Hello {{recipient_name}},\n\n" +
          "$t(delivery_notes.delivery_note) no. {{number}} was delivered.\n\n" +
          "Created by: {{creator}}\n" +
          "Delivered by: {{actor}}\n" +
          "Customer: {{customer}}\n" +
          "Property: {{property_name}}\n" +
          "Address: {{property_address}}\n" +
          "Delivered at: {{delivered_at}}\n\n" +
          "Direct link:\n{{link}}\n\n" +
          "Best regards\n\n" +
          "Your FormWeg.de team",
      },
    },
  },
};

export default translations;
